<template>
    <div class="w-100">
        <div class="row w-100 mx-0">
            <div class="col-12" style="border-bottom:1px solid #dcdddd">
                <div v-if="pageIs=='contact'" class="row my-3">
                    <div class="col-12" @click="toggleClick">
                        <button type="button" data-toggle="modal" data-target="#addOrganizationModal" class="btn bg-new-primary f-14 mr-2">
                            <i class="fa fa-edit f-14 cursor-pointer"></i> {{$ml.get('EDIT_COMPANY')}}
                        </button>  
                        <button type="button" @click="organizationCard(data._id.$oid)" class="btn mcBgDark text-white f-14">
                            <i class="fa fa-info-circle f-14 mr-2"></i> {{$ml.get('DETAIL_COMPANY')}}
                        </button>  
                    </div>
                    <div class="d-flex w-75 border py-3 mt-3 ml-3" :style="windowWidth<maxMobilSize ? 'display':'none'" id="companyDetailToggle">
                        <div class="col-6 f-12 border-right">
                            <div class="py-2 mb-2">
                                <span class="color-gray">{{$ml.get('STATUS')}}</span>
                                <span class="d-block">{{data.isCandidate ? $ml.get('LEAD'):$ml.get('CUSTOMER')}}</span>
                            </div>
    
                            <div class="py-2 mb-2" v-if="data.name!==undefined && data.name !=='' && data.name!==null">
                                <span class="color-gray">{{$ml.get('COMPANY_NAME')}}</span>
                                <span class="d-block">{{data.name}}</span>
                            </div>
    
                            <div class="py-2 mb-2" v-if="data.phoneNumbers!==undefined && data.phoneNumbers!=='' && data.phoneNumbers!==null && data.phoneNumbers.length>0">
                                <span class="color-gray">{{$ml.get('PHONE_NUMBERS')}}</span>
                                <span class="d-block" v-for="(i,index) in data.phoneNumbers">
                                        {{i}}
                                </span>
                            </div>
                            <div class="py-2 mb-2" v-if="data.faxNumbers!==undefined && data.faxNumbers!=='' && data.faxNumbers!==null && data.faxNumbers.length>0">
                                <span class="color-gray">{{$ml.get('FAKS_NUMBERS')}}</span>
                                <span class="d-block" v-for="(i,index) in data.faxNumbers">
                                        {{i}}
                                </span>
                            </div>
    
                            <div class="py-2 mb-2" v-if="data.emailAddresses!==undefined && data.emailAddresses!=='' && data.emailAddresses!==null && data.emailAddresses.length>0">
                                <span class="color-gray">{{$ml.get('EMAIL_ADDRESSES')}}</span>
                                <span class="d-block" v-for="(i,index) in data.emailAddresses">
                                        {{i}}
                                </span>
                            </div>
    
                            <div class="py-2 mb-2" v-if="data.webAddr!==undefined && data.webAddr!=='' && data.webAddr!==null">
                                <span class="color-gray">{{$ml.get('WEB_SITE')}}</span>
                                <span class="d-block">{{data.webAddr}}</span>
                            </div>
                        </div>
                        <div class="col-6 f-12">
                            <div class="py-2 mb-2" v-if="data.addr!==undefined && data.addr!=='' && data.addr!==null">
                                <span class="color-gray">{{$ml.get('ADDRESS')}}</span>
                                <span class="d-block">{{data.addr}}</span>
                            </div>
    
                            <div class="py-2 mb-2" v-if="data.postalCode!==undefined && data.postalCode!=='' && data.postalCode!==null">
                                <span class="color-gray">{{$ml.get('POST_CODE')}}</span>
                                <span class="d-block">{{data.postalCode}}</span>
                            </div>
    
    
                            <div class="py-2 mb-2" v-if="data.country!==undefined && data.country!=='' && data.country!==null">
                                <span class="color-gray">{{$ml.get('COUNTRY')}}</span>
                                <span class="d-block">{{data.country}}</span>
                            </div>
    
    
                            <div class="py-2 mb-2" v-if="data.city!==undefined && data.city!=='' && data.city!==null">
                                <span class="color-gray">{{$ml.get('CITY')}}</span>
                                <span class="d-block">{{data.city}}</span>
                            </div>
    
                            <div class="py-2 mb-2" v-if="data.town!==undefined && data.town!=='' && data.town!==null">
                                <span class="color-gray">{{$ml.get('DISTRICT')}}</span>
                                <span class="d-block">{{data.town}}</span>
                            </div>
    
                            <hr>
    
                            <div class="py-2 mb-2" v-if="data.taxOffice!==undefined && data.taxOffice!=='' && data.taxOffice!==null">
                                <span class="color-gray">{{$ml.get('TAX_ADMINISTRATION')}}</span>
                                <span class="d-block">{{data.taxOffice}}</span>
                            </div>
    
                            <div class="py-2 mb-2" v-if="data.taxNo!==undefined && data.taxNo!=='' && data.taxNo!==null">
                                <span class="color-gray">{{$ml.get('TAX_NUMBER')}}</span>
                                <span class="d-block">{{data.taxNo}}</span>
                            </div>
                        </div>
                    </div>
                   
                </div>
                <div class="companyDetail" v-else>
                    <div class="crm-modal-header hpx-50 d-flex align-items-center justify-content-between col-12 px-0" @click="toggleClick('companyDetailToggle')" v-if="field!=='dealCard'" >
                        <label class="m-0 align-self-center f-14 f-w-normal">{{$ml.get('DETAILS_COMPANY')}} </label>
                        <i class="fa fa-edit color-gray f-20 cursor-pointer editCompany d-none" @click="$emit('editOrg')"></i>
                        <!--<i class="icon-line-yuvarlakekle f-14 float-right mr-2" v-if="field==='organizationCard'" @click="editRelationship('organization')" data-toggle="modal" data-target="#relationship"></i>-->
                    </div>      
                </div>
            </div>
            <div class="col-12 f-12 mt-3 bg-white" :style="windowWidth<maxMobilSize ? {display:'none'}:{}" id="companyDetailToggle">
                        
                <div class="py-2 mb-2" v-if="data.name!==undefined && data.name!=='' && data.name!==null">
                    <span class="color-gray">{{$ml.get('COMPANY_NAME')}}</span>
                    <span class="d-block">{{data.name}}</span>
                </div>
                <div class="py-2 mb-2">
                    <span class="color-gray">{{$ml.get('STATUS')}}</span>
                    <span class="d-block">{{data.isCandidate ? $ml.get('LEAD'):$ml.get('CUSTOMER')}}</span>
                </div>
                <hr>
                
                <div class="py-2 mb-2" v-if="data.phoneNumbers!==undefined && data.phoneNumbers!=='' && data.phoneNumbers!==null && data.phoneNumbers.length > 0">
                    <span class="color-gray">{{$ml.get('PHONE_NUMBERS')}}</span>
                    <span class="d-block f-13" v-for="(i,index) in data.phoneNumbers">
                            {{i}}
                    </span>
                </div>
                <div class="py-2 mb-2" v-if="data.faxNumbers!==undefined && data.faxNumbers!=='' && data.faxNumbers!==null && data.faxNumbers.length > 0">
                    <span class="color-gray">{{$ml.get('FAKS_NUMBERS')}}</span>
                    <span class="d-block f-13" v-for="(i,index) in data.faxNumbers">
                            {{i}}
                    </span>
                </div>
                <div class="py-2 mb-2" v-if="data.emailAddresses!==undefined && data.emailAddresses!=='' && data.emailAddresses!==null && data.emailAddresses.length > 0">
                    <span class="color-gray">{{$ml.get('EMAIL_ADDRESSES')}}</span>
                    <span class="d-block f-13" v-for="(i,index) in data.emailAddresses">
                            {{i}}
                    </span>
                </div>
                <div class="py-2 mb-2" v-if="data.addr!==undefined && data.addr!=='' && data.addr!==null">
                    <span class="color-gray">{{$ml.get('ADDRESS')}}</span>
                    <span class="d-block f-13">{{data.addr}}</span>
                </div>
                <div class="py-2 mb-2" v-if="data.postalCode!==undefined && data.postalCode!=='' && data.postalCode!==null">
                    <span class="color-gray">{{$ml.get('POST_CODE')}}</span>
                    <span class="d-block f-13">{{data.postalCode}}</span>
                </div>
                <div class="py-2 mb-2" v-if="data.country!==undefined && data.country!=='' && data.country!==null">
                    <span class="color-gray">{{$ml.get('COUNTRY')}}</span>
                    <span class="d-block f-13">{{data.country}}</span>
                </div>
                <div class="py-2 mb-2" v-if="data.city!==undefined && data.city!=='' && data.city!==null">
                    <span class="color-gray">{{$ml.get('CITY')}}</span>
                    <span class="d-block f-13">{{data.city}}</span>
                </div>
                <div class="py-2 mb-2" v-if="data.town!==undefined && data.town!=='' && data.town!==null">
                    <span class="color-gray">{{$ml.get('DISTRICT')}}</span>
                    <span class="d-block f-13">{{data.town}}</span>
                </div>
                <div class="py-2 mb-2" v-if="data.webAddr!==undefined && data.webAddr!=='' && data.webAddr!==null">
                    <span class="color-gray">{{$ml.get('WEB_SITE')}}</span>
                    <span class="d-block f-13">{{data.webAddr}}</span>
                </div>
                <hr>
                <div class="py-2 mb-2" v-if="data.taxOffice!==undefined && data.taxOffice!=='' && data.taxOffice!==null">
                    <span class="color-gray">{{$ml.get('TAX_ADMINISTRATION')}}</span>
                    <span class="d-block f-13">{{data.taxOffice}}</span>
                </div>
                <div class="py-2 mb-2" v-if="data.taxNo!==undefined && data.taxNo!=='' && data.taxNo!==null">
                    <span class="color-gray">{{$ml.get('TAX_NUMBER')}}</span>
                    <span class="d-block f-13">{{data.taxNo}}</span>
                </div>
                    
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import CountrySelect from '@/components/country-select'
import RegionSelect from '@/components/region-select'
export default {
    name: 'organizationDetailPanel',
    components:{
        CountrySelect,
        RegionSelect
    },
    data () {
        return {
            selected:undefined,
            addPhoneText:"",
            addEmailText:"",
            addFaxText:"",
            city:"",
            town:"",
            country:"",
            isTurkeyCountry:false,
            oldCity:""
        }
    },
    props:["data","field","user","permission","pageIs"],
    computed: {
        ...mapState(['baseUrl','windowWidth','maxMobilSize','maxTabletSize']),
    },
    methods:{
        toggleClick(id){
            if(this.windowWidth<this.maxMobilSize){
                $("#"+id).slideToggle();
            }
        },
        organizationCard(id){
            if(id!==""){
                //localStorage.orgId=id
                //this.updateOrgId(id)
                window.open('/organizationCard/'+id, '_blank');
            }
        },
        ...mapActions([
            'editRelationship',
            'updateLoading'
        ]),
    },
    mounted(){
    },
    watch:{
        data:function(value){
            if(value.country!==undefined){
                this.country=value.country
                if(this.country=="Turkey" || this.country=="Türkiye"){
                    this.isTurkeyCountry=true;
                }else{       
                    this.isTurkeyCountry=false;
                }
            }
        }       
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.companyDetail:hover .editCompany{
    display: block !important;
}
.iptal:before{
    color:red
}
.updateInput{
    border: 0px;
    border-bottom: 1px solid #66D0FF80;
}
.showMore{
    height: 315px!important;
    overflow: hidden;
}
.add{
    color: #3767a0;
}
.add,.edit:hover{
    cursor: pointer;
}
.add:hover:after{
    content: "\e952";
    font-size: 18px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #3767a0;
}
.edit:hover:after{
    content: "\e913";
    font-size: 18px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #3767a0;
}
</style>
